import { createContext, useContext, useEffect, useState } from "react";

const ThemeContext = createContext({ mode: "system", resolved: "light", setMode: () => {} });
const media = () => window.matchMedia("(prefers-color-scheme: dark)");

export function ThemeProvider({ children }) {
  const [mode, setModeState] = useState(() => localStorage.getItem("gw_theme") || "system");
  const [systemDark, setSystemDark] = useState(() => media().matches);

  useEffect(() => {
    const mq = media();
    const onChange = (e) => setSystemDark(e.matches);
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, []);

  const resolved = mode === "system" ? (systemDark ? "dark" : "light") : mode;
  useEffect(() => {
    document.documentElement.classList.toggle("dark", resolved === "dark");
  }, [resolved]);

  const setMode = (m) => {
    localStorage.setItem("gw_theme", m);
    setModeState(m);
  };
  return <ThemeContext.Provider value={{ mode, resolved, setMode }}>{children}</ThemeContext.Provider>;
}

export const useTheme = () => useContext(ThemeContext);
